/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Col, Container, Row, Button, Card, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import DeleteClient from "../Modal/DeleteClient";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ChangePassword from "../Modal/ChangePassword";

const Clients = () => {
  const {t} = useTranslation();
  const [id, setId] = useState();
  const[changeId, setChangeId] = useState();
  const [, setUser] = useState([]);
  const[ChangePasswordModal, setChangePasswordModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [, setUserDelete] = useState(true);
  const [deletedId, setDeletedId] = useState("");
  const [users, setUsers] = useState([]);
  // const[botId,setBotId]=useState('');
  const [botID,setBotID] = useState('');
  const [, setActive] = useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const countPerPage = 10;

  const getAllBots = async (_id) => {
    try {
      const response = await axios.get(`${API_URL}/${API_VERSION}/bot/user/${_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      if (response.data.length !== 0) {
        const firstBotId = response.data[0].id;
        setBotID(firstBotId.id);
        localStorage.setItem("firstBot", firstBotId);
        navigate(`/admin/my-bots/${_id}/${firstBotId}`);
      } else {
        console.log("None");
        navigate(`/admin/my-bots/${_id}`);
      }
    }catch (error) {
      console.error("error",error);
    }
  };

  // const getAllBots = async() =>{
  //   try {
  //     return await new Promise(async(resolve,reject)=>{
  //       try {
  //         if(id){
  //           axios
  //           .get(`${API_URL}/${API_VERSION}/bot/user/${id[0]._id}`, {
  //             headers: {
  //               Authorization: `Bearer ${localStorage.getItem("token")}`
  //             }
  //           })
  //           .then((response) => {
  //             if(response.data.length!==0)
  //             {
  //               setBotId(response.data[0].id)
  //             }
  //               resolve();
  //             })
  //             .catch((error) => {
  //               reject(error);
  //             }); 
  //           }
  //       } catch (error) {
  //         reject(error)
  //       }
  //     })
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const columns = [
    {
      name: "Name",
      selector: "name",
    },
    {
      name: "Email",
      selector: "email",
    },
    {
      name: "Data",
      cell: (row) => {
        return (
          <>
            <p className="d-flex flex-wrap gap-2">
              <Link className="button" 
                onClick={() => getAllBots(row._id)}
                // to={botId ? `/admin/my-bots/${row._id}/${botId}`: `/admin/my-bots/${row.id}`}
              >
                <i className="fa-solid fa-robot"></i> {t("Bots")}
              </Link>
            </p>
          </>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <>
            <p className="d-flex flex-wrap gap-2">
              <Link className="button" to={`/admin/edit-client/${row._id}`}>
                <i className="fa-solid fa-pen-to-square"></i>
              </Link>
              <Link className="button" onClick={()=>{setChangePasswordModal(true) 
              setChangeId(row._id)
              }}>
              <i className="fa fa-key" aria-hidden="true"></i>
              </Link>
              <Button
                className="color_orange"
                variant=""
                onClick={() => openDeleteUserAlert(row._id)}
              >
                <i className="fa-solid fa-trash-can"></i>
              </Button>
            </p>
          </>
        );
      },
    },
    {
      name: "Status",
      cell: (row) => {
        return (
          <>
            <Form>
              <Form.Check
                type="switch"
                id={row._id}
                defaultChecked={row.is_active}
                onChange={(e) => updateUser(e, row._id)}
              />
            </Form>
          </>
        );
      },
    },
  ];

  function openDeleteUserAlert(id) {
    setDeletedId(id);
    setModalShow(true);
  }

  function fetchUsers() {
    let setUserUrl = `${API_URL}/${API_VERSION}/users?role=user&page=${page}&limit=${countPerPage}`;
    if (searchValue) {
      setUserUrl += `&status=${searchValue}`;
    }
    axios
      .get(setUserUrl, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setUsers(response.data);
        setActive(response.data.docs.is_active);
        const _users = response.data.docs.map((id) => id);
        setId(_users);
        setActive(response.data.docs.is_active);
        setUser(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    fetchUsers();
  }, [page]);
  
  // useEffect(()=>{
  //   getAllBots();
  // },[id])

  function updateUser(e, id) {
    const newIsActive = e.target.checked;
    axios
      .get(`${API_URL}/${API_VERSION}/userStatus/${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setUser(response.data);
        setActive(response.data.is_active);
       
      })
      .catch((error) => {
        console.log(error);
      });
    setId(id);
    setActive(newIsActive);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/userStatus/${id}`,
        {
          newIsActive,
        },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setActive(newIsActive);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function deleteUser(uId) {
    if (uId) {
      await axios
        .delete(`${API_URL}/${API_VERSION}/user/active-plan/${uId}`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {})
        .catch((error) => {});

      await axios
        .delete(`${API_URL}/${API_VERSION}/users/${uId}`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setUserDelete(true);
          setModalShow(true);
          navigate("/admin/clients");
          fetchUsers();
          setModalShow(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  
  return (
    <>
      <section className="clients_main">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Header as="h5">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">{t("Users")}</h3>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <input
                        type="text"
                        className="form-control"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                      <button className="button" onClick={() => fetchUsers()}>
                        {t("Search")}
                      </button>

                        <button className="button" onClick={()=>navigate('/admin/add-client')}>
                        {t("Add User")}
                      </button>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="client_table">
                    <DataTable
                      columns={columns}
                      data={users.docs}
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationTotalRows={users.totalDocs}
                      paginationPerPage={countPerPage}
                      paginationComponentOptions={{
                        noRowsPerPage: true,
                      }}
                      onChangePage={(page) => setPage(page)}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <DeleteClient
        show={modalShow}
        onHide={() => setModalShow(false)}
        onDelete={() => deleteUser(deletedId)}
      />
      <ChangePassword
        show={ChangePasswordModal}
        id={changeId}
        onHide={() => setChangePasswordModal(false)}
      />
    </>
  );
};

export default Clients;
